import { Middleware } from '@reduxjs/toolkit'
import { MapActions, MapSelector } from '../Map'


let timeoutId;
export const mapMiddleware: Middleware = (store) => (next) => async (action:any) => {
  if(!action.type.startsWith('mapSlice')){
    return next(action);
  }

  switch (action.type) {
    case 'mapSlice/setPopupDetail': {

      clearTimeout(timeoutId)
      if (action.payload.timeout === null || !action.payload.timeout) {
        return next(action)
      }
      const popUpDetail = MapSelector.getPopUpDetail(store.getState())
      timeoutId = setTimeout(() => {
        store.dispatch(MapActions.setPopupDetail({ visible: false }))
      }, action.payload.timeout || popUpDetail.timeout)
      break
    }
    default:
      return next(action)
  }

  return next(action)
}